import { GlobalResponseObject } from "../../global-response-object";
import { CreateUserDto } from "./user-dto";



export class UserResponseModel extends GlobalResponseObject{
    data?: CreateUserDto;
    success?: boolean;
}
